<template>
  <div class="flash-topic-selector">
    <div class="topic-scroll-wrapper" @wheel.prevent="onWheel">
      <button
        v-for="item in items"
        :key="item.code"
        :class="['topic-pill', { active: selected === item.code }]"
        @click="$emit('change', item.code)"
      >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    selected: { type: Number, default: 0 },
  },
  methods: {
    onWheel(e) {
      const el = e.currentTarget
      el.scrollLeft += e.deltaY
    },
  },
}
</script>

<style scoped>
.flash-topic-selector {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 48px 0 24px;
  pointer-events: none;
  background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%);
}
.topic-scroll-wrapper {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  pointer-events: auto;
  padding: 4px 12px;
  box-shadow: inset 12px 0 8px -8px rgba(0,0,0,0.5), inset -12px 0 8px -8px rgba(0,0,0,0.5);
}
.topic-scroll-wrapper::-webkit-scrollbar {
  display: none;
}
.topic-pill {
  flex-shrink: 0;
  padding: 5px 14px;
  border-radius: 100px;
  border: none;
  background: rgba(255,255,255,0.13);
  color: rgba(255,255,255,0.85);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.topic-pill:hover {
  background: rgba(255,255,255,0.22);
  color: #fff;
}
.topic-pill.active {
  background: rgba(255,255,255,0.9);
  color: #111;
  font-weight: 600;
}
</style>
